export default __webpack_public_path__ + "static/pack_en-2faa2c507a538931ed2c4da378c5d435.png";